'use client';

import HomeDashboard from './_components/Home/HomeDashboard';

export default function WorkspacePage() {
  return <HomeDashboard />;
}
